var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-3 custom-callout",
      attrs: { "border-color": "orange", "has-toggle": false }
    },
    [
      _c(
        "validation-observer",
        {
          ref: "absenceInterventionPlanRef",
          attrs: { novalidate: "", tag: "form" }
        },
        [
          _c("icon-view", {
            staticClass: "icon-view__extended",
            attrs: {
              icon: "fas fa-flag",
              "icon-background": "#fff",
              "icon-color": "#FF7058",
              "icon-size": "16px",
              title: "Documentar Ausencia"
            }
          }),
          _c("div", { staticClass: "row mt-4" }, [
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-date-picker", {
                            attrs: {
                              "class-container": "w-100",
                              "custom-error-msg":
                                "Favor de seleccionar la fecha.",
                              error: errors[0],
                              label: "Fecha:",
                              "max-date": _vm.maxDate,
                              "min-date": _vm.minDate,
                              placeholder: "DD/MM/YYYY"
                            },
                            model: {
                              value: _vm.model.date,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "date", $$v)
                              },
                              expression: "model.date"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            attrs: {
                              id: "absenceReasonDD",
                              "custom-error-msg":
                                "Favor de seleccionar la razón de Ausencia.",
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Razón de Ausencia:",
                              options: _vm.absenceReasons,
                              placeholder: "Seleccione"
                            },
                            model: {
                              value: _vm.model.absenceReason,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "absenceReason", $$v)
                              },
                              expression: "model.absenceReason"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm.otherAbsenceReasonSelected
              ? _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    id: "otherAbsence",
                                    "custom-error-msg":
                                      "Favor de completar el campo.",
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Especifique Razón:",
                                    maxlength: "50",
                                    placeholder: "Razón"
                                  },
                                  model: {
                                    value: _vm.model.otherAbsenceReason,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "otherAbsenceReason",
                                        $$v
                                      )
                                    },
                                    expression: "model.otherAbsenceReason"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2881061853
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-end align-items-center mt-4 mb-2"
            },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-times-circle",
                  text: "Cancelar",
                  variant: "outline-danger mr-3 px-3"
                },
                on: { click: _vm.onCancelHandler }
              }),
              _c("action-button", {
                attrs: {
                  i: "fas fa-save",
                  text: "Guardar",
                  variant: "success px-3"
                },
                on: { click: _vm.onSaveHandler }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }